import { IParams } from 'services/common/@types';

type IUserId = string | number;

interface IUpdateUserParams extends Omit<IParams, 'params'> {
  name: string;
  lastname: string;
  id: IUserId;
  apiVersion?: number;
  locale?: string;
}

interface IUserBaseParams extends Omit<IParams, 'params'> {
  id: IUserId;
}

interface IUserVerifyEmailAvailability extends Omit<IParams, 'params'> {
  email: string;
}

interface IUserGetAccountParams extends Omit<IParams, 'params'> {
  familyId: string;
}

enum IEUserIdMatchParam {
  PARAM = 'userId',
  PATTERN = ':userId',
}

enum IEFamilyIddMatchParam {
  PARAM = 'familyId',
  PATTERN = ':familyId',
}

export { IEUserIdMatchParam, IEFamilyIddMatchParam };
export type { IUpdateUserParams, IUserBaseParams, IUserId, IUserVerifyEmailAvailability, IUserGetAccountParams };
